import type { HTMLAttributes, ReactNode } from 'react';

import './Card.styl';

type Props = Omit<HTMLAttributes<HTMLDivElement>, 'title'> & {
  padding?: 14 | 18 | 22;
  dark?: boolean;
  /** Light glass, like the live timer: a soft palette wash, the app's rings and dots, 24 px corners. */
  glass?: boolean;
  tone?: 'risk';
  title?: ReactNode;
  subtitle?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
};

export function Card({ padding = 18, dark = false, glass = false, tone, title, subtitle, aside, className, children, ...rest }: Props) {
  const classes = ['a-card', `a-card--p${padding}`];
  if (dark) classes.push('a-card--dark');
  if (glass) classes.push('a-card--glass');
  if (tone) classes.push(`a-card--${tone}`);
  if (className) classes.push(className);
  return (
    <div className={classes.join(' ')} {...rest}>
      {title || aside ? (
        <div className="a-card__head">
          <div>
            {title ? <div className="a-card__title">{title}</div> : null}
            {subtitle ? <div className="a-card__subtitle">{subtitle}</div> : null}
          </div>
          {aside ? <div className="a-card__aside">{aside}</div> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}
